import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './i18n'
import { Routing } from './routing';
import { Layout } from './layout';
import { StoreProvider } from './store';
import { initFavicon, initTitle } from './initial-scripts';

initTitle()
initFavicon()

createRoot(document.getElementById('root') as HTMLElement)
  	.render(
		<StrictMode>
			<StoreProvider>
				<Layout>
					<Routing/>
				</Layout>
			</StoreProvider>
		</StrictMode>
  	)